import { getCommentsTemplate, getVueCommentsTemplate } from "../../shortcodes/templates";

let commentsWidget = null;
const visualizeCommentsWidget = content => {
  commentsWidget = content.querySelectorAll('[data-tiny-mce-component="landercomments"]');
  if (commentsWidget.length > 0) {
    commentsWidget.forEach(item => {
      const quizData = item.getAttribute("data-comments-widget-data");
      item.outerHTML = getCommentsTemplate(quizData);
    });
  }
};

const serializeCommentsWidget = content => {
  const commentsWidgetData = content.querySelectorAll('[data-tiny-mce-component="landercomments"]');
  if (commentsWidgetData.length > 0) {
    commentsWidgetData.forEach(item => {
      const quizData = item.getAttribute("data-comments-widget-data");
      item.innerHTML = getVueCommentsTemplate(quizData);
    });
  }
};

export { visualizeCommentsWidget, serializeCommentsWidget };
